﻿import React, { useState, useEffect } from 'react';
import { AuditingTable } from "components/auditing";
import { AccountService } from "services";
import { EarnedRecognitionService } from "services/EarnedRecognitionService";
import { Tabs } from 'components/navigation';
import { UserHasAccess } from 'components/user-access';

export function AccountChangelog(props) {

    const canAccessEarnedRecognition = UserHasAccess("Internal:Super");

    const noDataMessage = "It looks like no previous changes have been made to your account settings.";
    const [loading, setLoading] = useState(true);
    const [tableData, setTableData] = useState(null);
    const [tableRecordCount, setTableRecordCount] = useState(0);
    const [selectedTab, setSelectedTab] = useState("Account");
    const [tabSettings] = useState([
        { key: "ACCOUNT", title: "Account", selected: true },
        ...(canAccessEarnedRecognition ? [{ key: "EARNED_RECOGNITION", title: "Earned Recognition", selected: false }] : []),
    ]);

    useEffect(() => {
        if (selectedTab) {
            setLoading(true);
            setTableData([]);
            setTableRecordCount(0);
        }
    }, [selectedTab]);

    function onTableChange(pageSize, pageNumber, startDate, endDate) {
        setLoading(true);
        const serviceCall = canAccessEarnedRecognition && selectedTab === "Earned Recognition"
            ? EarnedRecognitionService.getChangelog(pageSize, pageNumber, startDate, endDate)
            : AccountService.getChangelog(pageSize, pageNumber, startDate, endDate);
        return serviceCall.then(r => {
            setTableData(r.data);
            setTableRecordCount(r.totalCount);
            setLoading(false);
        });
    }

    function onTabClick(tabIndex) {
        setSelectedTab(tabSettings[tabIndex].title);
    }

    return (
        <>
            <div className="row">
                <h2>History</h2>
                <div className="spacer-bottom">
                    <Tabs tabs={tabSettings.map(tab => ({ ...tab, selected: tab.title === selectedTab }))} onClick={onTabClick} disabled={loading} />
                </div>
            </div>
            <AuditingTable hideHeader key={selectedTab} data={tableData} totalCount={tableRecordCount} onChange={onTableChange} noDataMessage={noDataMessage} loading={loading} />
        </>
    );

}